import { memo } from 'react';

import { LedgerAccountEvent as ILedgerAccountEvent } from 'models';

import useTranslation from 'hooks/useTranslation';

import { StyledBox, Label } from '../PurchaseInvoice.style';
import { LedgerAccountEventsList } from './LedgerAccountEvents.style';
import Loader from 'components/page-loader';
import LedgerAccountEvent from './LedgerAccountEvent';

interface LedgerAccountEventsProps {
  isLoading: boolean;
  ledgerAccountEvents: ILedgerAccountEvent[];
}

const LedgerAccountEvents = ({
  isLoading,
  ledgerAccountEvents,
}: LedgerAccountEventsProps) => {
  const { t } = useTranslation();

  return (
    <StyledBox>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Label>
            {t('#portal.purchaseinvoice.detail.ledgeraccountevents')}
          </Label>
          <LedgerAccountEventsList>
            {ledgerAccountEvents &&
              ledgerAccountEvents.map((laEvent) => (
                <LedgerAccountEvent
                  key={laEvent.Id}
                  ledgerAccountEvent={laEvent}
                />
              ))}
          </LedgerAccountEventsList>
        </>
      )}
    </StyledBox>
  );
};

export default memo(LedgerAccountEvents);
